<template>
  <v-container fluid class="creativeproject-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-project`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-heart-box</v-icon>
            Creative Project
          </v-tab>
          <v-tab-item
            :value="'tab-project'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">Edit Creative Project</p>
                      <v-menu
                          ref="edit_projectreqdate"
                          v-model="edit_projectreqdate"
                          :close-on-content-click="false"
                          :return-value.sync="edit_creativeproject.projectreqdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="edit_creativeproject.projectreqdate"
                              label="Completion Date"
                              v-bind="attrs"
                              v-on:change="updateChangedValue($event, 'projectreqdate')"
                              v-bind:error="errorindex == 3"
                              v-on="on"
                              single-line 
                              hint="Please choose the request completion date"
                              >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="edit_creativeproject.projectreqdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="edit_projectreqdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.edit_projectreqdate.save(edit_creativeproject.projectreqdate); updateChangedValue(edit_creativeproject.projectreqdate, 'projectreqdate')"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          outlined
                          type="number"
                          class="mb-4"
                          :value="initvalue.projectprogress"
                          v-on:change="updateChangedValue($event, 'projectprogress')"
                          dense
                          placeholder="Project Progress"
                          hint="Enter the project progress"
                          persistent-hint>
                        </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Accept', 'Working', 'Completed']"
                        :value="initvalue.projectstatus"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'projectstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the status">
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/creativeproject/team/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editCreativeProject()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";
import { formatStdDate } from '@/mixins/date';

export default {
  data () {
    return {
      initvalue: {},
      edit_creativeproject: {},
      change_creativeproject: {},
      edit_projectreqdate: null,
      errorindex: null,
    }
  },
  methods: {
    ...mapActions('CreativeProject', ['updateCreativeProjectRequest', 'getCreativeProjectsRequest']),
    async editCreativeProject() {
      this.change_creativeproject._id = this.initvalue._id;
      await this.updateCreativeProjectRequest(this.change_creativeproject);
      router.push('/creativeproject/team/list');
    },
    updateChangedValue(value, field){
      this.change_creativeproject[field] = value;
    },
  },
  computed: {
    ...mapState('CreativeProject', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.edit_creativeproject = Object.assign({}, this.initvalue);
    this.edit_creativeproject.projectreqdate = formatStdDate(this.initvalue.projectreqdate);
    if(!this.initvalue._id) this.$router.push({ name: 'CreativeProjectTeamList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
